import { dynamicRender } from './utils'

dynamicRender({
    componentName: 'Search'
})